import { TTransaction } from 'structure/bridge/store/transactionsAtom';
import { Address, encodePacked, keccak256, pad } from 'viem';
import { firstDecimals } from './bridgeStateHelpers';
import { DECIMALS_INTERNAL } from '../constants/constants';

export function getTxPayload(transaction: TTransaction) {
  const PT_SEND = 0;
  const _toAddress = pad(
    transaction.userAddress
  ).toLowerCase() as `0x${string}`;
  const _fromAddress = _toAddress;
  const ld2sdRate = BigInt(
    10 **
      ((transaction?.token?.decimals ?? 18) -
        (transaction?.token?.sharedDecimals ?? 10))
  ); // decimals minus shared decimals

  // minAmount is bigint string
  const amountSDString = (
    firstDecimals(parseInt(transaction.minAmount), DECIMALS_INTERNAL) /
    parseInt(ld2sdRate.toString())
  ).toString();

  const amountSD = BigInt(parseInt(amountSDString));

  const calculatedPayload = encodePacked(
    ['uint8', 'bytes32', 'uint64', 'bytes32'],
    [PT_SEND, _toAddress, amountSD, _fromAddress]
  );
  return calculatedPayload;
}

export function getTxPayloadHash(payload: `0x${string}`) {
  const calculatedPayloadHash = keccak256(payload);
  return calculatedPayloadHash;
}

// export function remoteAndLocalPath(
//   remoteAddress: Address,
//   localAddress: Address
// ) {
//   return encodePacked(
//     ['address', 'address'],
//     [remoteAddress, localAddress] // remote local relative to the endpoint
//   );
// }
